import { createStyles, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import { FormikProps } from 'formik';
import React from 'react';
import { TranquiTheme } from '../../containers/App/theme';
import { CssSpreadType } from '../../utils/css-spread-type';
import TextField, { TextFieldProps } from '../TextField/TextField';

export type IFormikTextField = {
  valueId: string;
  formik: FormikProps<any>;
  'data-test'?: string;
};

type IFormikTextFieldProps = TextFieldProps & IFormikTextField;
const FormikTextField: React.FC<IFormikTextFieldProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const {
    className,
    valueId,
    formik: { values, errors, handleChange, touched, handleBlur },
    'data-test': dataTest,
    ...other
  } = props;

  const value = ((values[valueId] || values[valueId] === 0) ? values[valueId] : '');

  return (
    <TextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      name={valueId}
      data-test={dataTest || valueId}
      className={cn(classes.root, className)}
      FormHelperTextProps={{ className: classes.helper }}
      value={value}
      onChange={handleChange}
      error={!!errors[valueId] && !!touched[valueId]}
      helperText={errors[valueId] && touched[valueId] ? errors[valueId] : other.helperText}
      onBlur={handleBlur}
      inputProps={{
        ...other.inputProps,
      }}
    />
  );
};

export default FormikTextField;

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    '& .MuiFormLabel-root': {

    },
    '& .MuiInputLabel-formControl': {
      position: 'unset',
      transform: 'unset',
      marginBottom: '0.5em',
    },
    '& .MuiOutlinedInput-root': {
      borderColor: `${theme.palette.text5.main}!important`,
      color: theme.palette.text2.main,
      '&.Mui-focused ': {
        '& .MuiOutlinedInput-notchedOutline': {
          padding: '0.8em 1em',
          borderColor: theme.palette.secondary.main,
        },
      },
      '& legend span': {
        display: 'none',
      },
    },
    '& .Mui-focused': {
      color: theme.palette.black.main,
    },
    '& .Mui-error': {
      color: theme.palette.salmon.main,
    },
  },
  helper: {
    margin: theme.spacing(1, 0, 0),
    lineHeight: 1.1,
    ...(theme.typography.small as CssSpreadType),
    color: theme.palette.text3.main,
  },
}));
